import { useFormContext } from "react-hook-form";
import { useEffect, useCallback } from "react";

export function useDebouncedWatch<T>(
  callback: (data: T) => void,
  delay: number = 500
) {
  const { watch } = useFormContext();

  const debouncedCallback = useCallback(
    (data: T) => {
      const timer = setTimeout(() => {
        callback(data);
      }, delay);

      return () => clearTimeout(timer);
    },
    [callback, delay]
  );

  useEffect(() => {
    const subscription = watch((data) => {
      debouncedCallback(data as T);
    });
    return () => subscription.unsubscribe();
  }, [watch, debouncedCallback]);
} 